<template>
  <div class="container text-center">
    <h2 class="center-title">Order Received</h2>
    <p>
      Thank you for your order. Please allow us 1-2 days to review it, and then
      we will get in touch with you to discuss delivery.
    </p>

    <table class="w-100 table table-striped">
      <tbody>
        <tr>
          <td>Order Number:</td>
          <td>{{ order.id }}</td>
        </tr>
        <tr>
          <td>Date:</td>
          <td>{{ order.order_date }}</td>
        </tr>
        <tr>
          <td>Total:</td>
          <td>AED {{ parseFloat(order.total).toFixed(2) }}</td>
        </tr>
      </tbody>
    </table>
    <h3 class="center-title mt-4">Order Summary</h3>
    <table class="w-100 table table-striped">
      <thead class="thead-light">
        <tr>
          <th>Item ID</th>
          <th>Description</th>
          <th>UoM</th>
          <th>Qty</th>
          <th>Unit Price</th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(orderItem, index) in order.order_items" :key="index">
          <td>{{ orderItem.item_id }}</td>
          <td>{{ orderItem.description }}</td>
          <td>{{ orderItem.UoM }}</td>
          <td>{{ orderItem.qty }}</td>
          <td>
            AED {{ parseFloat(orderItem.price / orderItem.qty).toFixed(2) }}
          </td>
          <td>AED {{ parseFloat(orderItem.price).toFixed(2) }}</td>
        </tr>
      </tbody>
      <tfoot class="font-weight-bold">
        <tr>
          <td>Shipping</td>
          <td></td>
          <td></td>

          <td>{{ getOrderTotalQty }}</td>
          <td></td>
          <td>AED {{ order.shipping }}</td>
        </tr>
        <tr>
          <td>Vat (5%)</td>
          <td></td>
          <td></td>

          <td>{{ getOrderTotalQty }}</td>
          <td></td>
          <td>AED {{ order.vat }}</td>
        </tr>
        <tr>
          <td>Total</td>
          <td></td>
          <td></td>

          <td>{{ getOrderTotalQty }}</td>
          <td></td>
          <td>AED {{ getOrderTotalPrice }}</td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>
<script>
export default {
  name: "Cart",
  data() {
    return {
      checkoutFields: {},
      order: {},
    };
  },
  computed: {
    getOrderTotalQty: function () {
      var total = 0;
      this.order.order_items.forEach(function (item) {
        total += item.qty;
      });
      return total;
    },
    getOrderTotalPrice: function () {
      var total = 0;
      this.order.order_items.forEach(function (item) {
        total += parseFloat(item.price);
      });
      return total.toFixed(2);
    },
  },
  mounted() {
    this.$axios
      .get("order", { params: { order_id: this.$route.params.id } })
      .then((res) => {
        this.order = res.data.order;
      });
  },
};
</script>

<style scoped>
.table {
  background: #f8f8f8;
}
.table thead {
}
</style>